import { useMemo } from 'react';

import { cn } from 'app/utils/styles.utils';
import { BANNER_CONTENT, IS_GENERAL_BANNER, IS_MAIN_BANNER_ACTIVE } from 'app/constants/banner';
import { bannerVariants } from 'app/theme/banner';

const Banner = () => {
  const variant = useMemo(
    () => (IS_GENERAL_BANNER ? 'general' : 'technical'),
    [],
  );

  if (!IS_MAIN_BANNER_ACTIVE) return null;

  return (
    <div
      className={cn(
        bannerVariants({
          variant,
        }),
      )}>
      <div className="w-full text-center">
        <span className="font-semibold">{BANNER_CONTENT[variant].title}</span> –{' '}
        {BANNER_CONTENT[variant].message}
      </div>

      {/* <div className="w-4">
        <Icons.close
          className={clsx('h-4 w-4', ICON_COLOR_MAP[variant])}
          strokeWidth={3}
        />
      </div> */}
    </div>
  );
};

export default Banner;
